import styles from "../assets/stylesheets/VbsSignup.module.css";

export default function VbsSignup() {
  return (
    <div className={styles.scc__vbs__container}>
      <iframe
        className={styles.scc__vbs__form}
        src="https://docs.google.com/forms/d/e/1FAIpQLSdiZwSHLf6RxoDfriLSkXFQG9C7kWgpT7A69iT8Zu2Pg4Yyjw/viewform?embedded=true"
        title="gottaMove"
        frameborder="0"
        marginheight="0"
        marginwidth="0"
      >
        Loading…
      </iframe>
    </div>
  );
}
